import moment from "moment"
import React, { useContext } from "react"
import Actions from "pages/Reports/VerifyMyTeams/ActionButton/Actions"
import projectreport from "../../../assets/images/fullreport.png"
import Reporticon from "../../../assets/images/document_accept.svg"
import Imageicon from "../../../assets/images/image_images.svg"
import { MyContext } from "../../../pages/Reports/VerifyMyTeams/index"

const MobileOverall = ({ data }) => {
  const {
    summaryDatateam,
    handleverifyScreenproject,
    fullviewteamreport,
    renderWorkStatus,
    classnames,
    selectToggle,
    handleverifyScreenrow,
    summaryData,
    isMobileTeam,
    compactView
  } = useContext(MyContext)

  return (
    <>
      <div>
        <div className="text-center d-block mb-2 text-uppercase font-weight-bold">
          OverAll Summary
        </div>

        <table className="table table-align-mobile">
          <tbody>
            <tr>
              <th scope="row" className="text-uppercase">
                Name
              </th>
              <td>
                <span className="mobile-td">
                  {!selectToggle
                    ? `${data.clientName}_${data.projectName}`
                    : `${data?.displayName}`}
                </span>
              </td>
            </tr>
            <tr>
              <th scope="row" className="text-uppercase">
                In
              </th>
              <td>
                <span className="mobile-td">
                  {moment(data?.startTime).format("HH:mm:ss")}
                </span>
              </td>
            </tr>
            <tr>
              <th scope="row" className="text-uppercase">
                Out
              </th>
              <td>
                <span className="mobile-td">
                  {moment(data?.endTime).format("HH:mm:ss")}
                </span>
              </td>
            </tr>
            <tr>
              <th scope="row" className="text-uppercase">
                Hours
              </th>
              <td style={{ color: "orange" }}>{data?.totalHours}</td>
            </tr>
            {compactView == 2 && (
              <tr>
                <th scope="row" className="text-uppercase">
                  Active
                </th>
                <td>{data?.activeHours}</td>
              </tr>
            )}
            {compactView == 2 && (
              <tr>
                <th scope="row" className="text-uppercase">
                  Private
                </th>
                <td>{data?.privateHours}</td>
              </tr>
            )}
            <tr>
              <th scope="row" className="text-uppercase">
                Break
              </th>
              <td>{data?.breakHours}</td>
            </tr>
            {compactView == 2 && (
              <tr>
                <th scope="row" className="text-uppercase">
                  Idle
                </th>
                <td>{data?.idleHours}</td>
              </tr>
            )}
            <tr>
              <th scope="row" className="text-uppercase">
                On Evaluation
              </th>
              <td>{data?.onEvaluationHours}</td>
            </tr>
            <tr>
              <th scope="row" className="text-uppercase">
                Status
              </th>
              <td>{data?.workReportStatusName}</td>
            </tr>
            <tr>
              <th scope="row" className="text-uppercase">
                Action
              </th>
              <td>
              <Actions
                  Reporticon={Reporticon}
                  Imageicon={Imageicon}
                  summaryDatateam={summaryDatateam}
                  handleverifyScreenproject={handleverifyScreenproject}
                  fullviewteamreport={fullviewteamreport}
                  renderWorkStatus={renderWorkStatus}
                  classnames={classnames}
                  projectreport={projectreport}
                  row={data}
                  handleverifyScreenrow={handleverifyScreenrow}
                  summaryData={summaryData}
                  isMobile={isMobileTeam}
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  )
}
export default MobileOverall
